module.exports = __webpack_public_path__ + "static/media/map-creation-illustration.12198189.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/map-creation-illustration.png
// module id = 412
// module chunks = 0